import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardActionsInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatCardActions } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';

@Component({
  selector: 'tb-card-actions',
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, MatCardActions],
  template: `
    <mat-card-actions
      [class]="input().styleClasses | parse: context() | async"
      [align]="(input().align | parse: context() | async) ?? 'end'"
    >
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-card-actions>
  `,
  styles: `
    tb-card-actions {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class CardActionsComponent extends WidgetInputBaseComponent<CardActionsInput> {}
